import reportUserCellUrl from './reportUserCellComponent.html';

export default {
  bindings: {
    user: '<',
  },
  controllerAs: 'ctrl',
  templateUrl: reportUserCellUrl,
};
